<div class=" h-full rounded-lg border border-gray-200 bg-white  p-6 shadow-sm dark:border-gray-700 dark:bg-gray-900">
  <h3 class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
    <i class="pi pi-mobile mr-2 text-green-500"></i>
    {{ 'dashboard.charts.appUsage.title' | translate }}
  </h3>

  @if (isLoading()) {
    <div class="flex h-48 flex-col items-center justify-center space-y-2">
      <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
      <span class="text-sm text-gray-500">{{ 'common.loading' | translate }}</span>
    </div>
  } @else if (error()) {
    <div class="flex h-48 items-center justify-center">
      <p class="text-red-600 dark:text-red-400">{{ error() }}</p>
    </div>
  } @else {
    <div class="h-64">
      <p-chart
        type="line"
        [data]="chartData()"
        [options]="chartOptions()"
        class="h-full w-full"
      >
      </p-chart>
    </div>
  }
</div>
